import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    CircularProgress,
    IconButton,
    Tab,
    Tabs,
    Typography,
    useMediaQuery,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions/transition';
import React, { FC, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Discipline, StatsTab } from '../../services/enum';
import useGetCourses from '../../services/use-get-courses';
import useGetStats from '../../services/use-get-stats';
import { StatContent } from './StatContent';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const StatsDialog: FC = () => {
    const navigate = useNavigate();
    const { date, r, c } = useParams<{
        date: string;
        r: string;
        c: string;
    }>();

    const { data: program } = useGetCourses(date || '');
    const reunion = program?.reunions.find(
        (reu) => reu.numOfficiel === Number(r)
    );
    const course = reunion?.courses.find((cou) => cou.numOrdre === Number(c));
    const [selectedTab, setSlectedTab] = useState(StatsTab.HIPPODROME);

    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const { data: stats } = useGetStats(
        course?.hippodrome?.libelleLong || '',
        course?.montantPrix || 0,
        course?.discipline || Discipline.ATTELE,
        course?.heureDepart || 0
    );

    return (
        <Dialog
            open
            fullScreen={isMobile}
            TransitionComponent={Transition}
            onClose={() => navigate(-1)}
            maxWidth="sm"
        >
            <Box
                bgcolor={'primary.main'}
                width={'130px'}
                height={'55px'}
                display={'flex'}
                alignItems={'center'}
                sx={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    clipPath: 'polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%)',
                }}
            >
                <Typography color="white" ml={2}>
                    Statistiques
                </Typography>
            </Box>

            {/* HEADER */}
            <IconButton
                onClick={() => navigate(-1)}
                sx={{ position: 'absolute', right: 8, top: 8 }}
            >
                <CloseIcon />
            </IconButton>
            {stats === undefined ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="50vh"
                    minWidth={"30vw"}
                >
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <DialogContent sx={{ height: '65vh', mt: 4, px: isMobile ? 0.5 : 2 }}>
                    <Tabs
                        value={selectedTab}
                        onChange={(_, value) => setSlectedTab(value)}
                        variant="fullWidth"
                    >

                        <Tab value={StatsTab.HIPPODROME} label="Hippodrome" />
                        <Tab value={StatsTab.DISCIPLINE} label="Discipline" />
                        <Tab value={StatsTab.MONTANT} label="Montant" />
                        <Tab value={StatsTab.TOP1} label="Top 1" />
                    </Tabs>

                    <StatContent
                        stat={
                            selectedTab === StatsTab.HIPPODROME
                                ? stats.hippodrome
                                : selectedTab === StatsTab.DISCIPLINE
                                    ? stats.discipline
                                    : selectedTab === StatsTab.MONTANT
                                        ? stats.price
                                        : stats.onlyOne
                        }
                        raceFrom10={stats.nbRaceFromLastBetween10And25}
                        raceFrom25={stats.nbRaceFromLastAbove25}
                    />
                </DialogContent>
            )}
        </Dialog>
    );
};

export default StatsDialog;
